import { lazy, Suspense } from 'react';
import type { RouteObject } from 'react-router-dom';
import NotFound from '../pages/NotFound';

const HomePage = lazy(() => import('../pages/home/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const ContactPage = lazy(() => import('../pages/contact/page'));
const ImpressumPage = lazy(() => import('../pages/impressum/page'));
const DatenschutzPage = lazy(() => import('../pages/datenschutz/page'));
const PortfolioPage = lazy(() => import('../pages/portfolio/page'));
const FreiburgPage = lazy(() => import('../pages/freiburg/page'));

const PageLoader = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="flex flex-col items-center gap-4">
      <div className="w-10 h-10 border-4 border-brand-green border-t-transparent rounded-full animate-spin" />
      <p className="text-sm text-gray-500 font-medium">Seite wird geladen…</p>
    </div>
  </div>
);

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Suspense fallback={<PageLoader />}><HomePage /></Suspense>,
  },
  {
    path: '/services',
    element: <Suspense fallback={<PageLoader />}><ServicesPage /></Suspense>,
  },
  {
    path: '/portfolio',
    element: <Suspense fallback={<PageLoader />}><PortfolioPage /></Suspense>,
  },
  {
    path: '/pricing',
    element: <Suspense fallback={<PageLoader />}><PricingPage /></Suspense>,
  },
  {
    path: '/about',
    element: <Suspense fallback={<PageLoader />}><AboutPage /></Suspense>,
  },
  {
    path: '/contact',
    element: <Suspense fallback={<PageLoader />}><ContactPage /></Suspense>,
  },
  {
    path: '/impressum',
    element: <Suspense fallback={<PageLoader />}><ImpressumPage /></Suspense>,
  },
  {
    path: '/datenschutz',
    element: <Suspense fallback={<PageLoader />}><DatenschutzPage /></Suspense>,
  },
  {
    path: '/webdesign-freiburg',
    element: <Suspense fallback={<PageLoader />}><FreiburgPage /></Suspense>,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
